import { c as create_ssr_component, b as add_attribute, e as escape, v as validate_component, d as each } from "../../../chunks/ssr.js";
import { W as WebsiteNav } from "../../../chunks/WebsiteNav.js";
import { c as classNames } from "../../../chunks/util.js";
import { P as PrimaryButton } from "../../../chunks/PrimaryButton.js";
const FriendTeaser = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { friend } = $$props;
  if ($$props.friend === void 0 && $$bindings.friend && friend !== void 0)
    $$bindings.friend(friend);
  return `<a${add_attribute("href", `/friends/${friend.friend_id}`, 0)}${add_attribute("class", classNames("block md:text-xl rounded-2xl border border-black bg-white p-4 sm:p-8"), 0)}><div>${friend.name ? `<div class="font-bold">${escape(friend.name)}</div>` : ``} <div>${escape(friend.email)}</div></div></a>`;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let bio;
  let { data } = $$props;
  if ($$props.data === void 0 && $$bindings.data && data !== void 0)
    $$bindings.data(data);
  bio = data.bio;
  return `${$$result.head += `<!-- HEAD_svelte-1h2riwl_START -->${$$result.title = `<title>Friends</title>`, ""}<link rel="icon" type="image/png" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><link rel="apple-touch-icon" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><!-- HEAD_svelte-1h2riwl_END -->`, ""} ${validate_component(WebsiteNav, "WebsiteNav").$$render($$result, { backButton: true }, {}, {})} <div class="max-w-screen-md mx-auto px-6 pb-8"><h1 class="text-center font-bold text-2xl sm:text-4xl pt-14">${escape(data.friends.length)} Friends</h1> <p class="text-center sm:text-xl pb-4" data-svelte-h="svelte-1tr4g23">Contact names auto-complete when you share posts.</p> <div class="flex justify-center pb-14">${validate_component(PrimaryButton, "PrimaryButton").$$render($$result, { size: "sm", href: "/friends/new" }, {}, {
    default: () => {
      return `Add friend`;
    }
  })}</div> <div class="space-y-4">${each(data.friends, (friend) => {
    return `${validate_component(FriendTeaser, "FriendTeaser").$$render($$result, { friend }, {}, {})}`;
  })}</div></div>`;
});
export {
  Page as default
};
